export default __webpack_public_path__ + "static/media/6-3.111a0366.mp3";